export const SEARCH_DATE_FORMAT = 'YYYY-MM-DD';
const SEARCH_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function isSearchDate(value: string | undefined): value is string {
  if (!value || !SEARCH_DATE_PATTERN.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysInMonth = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day <= daysInMonth[month - 1];
}

/** Fecha calendario local del asesor; nunca convierte el día a UTC. */
export function todaySearchDate(now = new Date()): string {
  const year = String(now.getFullYear()).padStart(4, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** La cota más tardía entre fechas ISO válidas. */
export function latestSearchDate(...values: (string | undefined)[]): string {
  return values.filter(isSearchDate).sort().at(-1) ?? '';
}

/**
 * Una vuelta anterior a la nueva ida tiene una continuación inequívoca: el
 * mismo día de la ida. El vacío y los borradores incompletos se preservan.
 */
export function reconcileSearchEndDate(start: string, end: string): string {
  return isSearchDate(start) && isSearchDate(end) && end < start ? start : end;
}

export function searchDateLocale(language: string | undefined): 'es' | 'en' {
  return language?.toLowerCase().startsWith('es') ? 'es' : 'en';
}

export function searchDateDisplayFormat(locale: 'es' | 'en'): string {
  return locale === 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
}
